module.exports = __webpack_public_path__ + "img/title-shiba.d9f86e8a.png";